import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Automatically inject the active language (?lang=en) and bearer token.
api.interceptors.request.use((config) => {
  const lang = (typeof window !== "undefined" && localStorage.getItem("mm_lang")) || "sv";
  const token = (typeof window !== "undefined" && localStorage.getItem("mm_auth_token")) || null;
  config.params = { ...(config.params || {}), lang };
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch"].includes(method)) {
    if (config.data && typeof config.data === "object" && !Array.isArray(config.data) && !(config.data instanceof FormData)) {
      if (config.data.lang === undefined) config.data = { ...config.data, lang };
    }
  }
  return config;
});
